// src/services/uploadService.ts
import apiClient from "./apiClient";

interface UploadResponse {
  status: string;
  message: string;
  avatarUrl: string | null;
}

export const uploadAdminProfilePicture = async (
  file: File,
): Promise<UploadResponse> => {
  const formData = new FormData();

  // "avatar" matches your Backend configuration
  formData.append("avatar", file);

  try {
    const response = await apiClient.post<UploadResponse>(
      "upload-image/admin-profile",
      formData,
    );
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const removeAdminProfilePicture = async (): Promise<UploadResponse> => {
  try {
    const response = await apiClient.delete<UploadResponse>(
      "upload-image/admin-profile",
    );
    return response.data;
  } catch (error) {

    throw error;
  }
};
